import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NotificationService } from 'src/app/services/notification-service';
import { WorkflowElementType } from '../../models/Enums/workflow-element-type';
import { SearchDialogResult } from './models/search-dialog-result';

@Component({
    selector: 'app-search-dialog',
    imports: [MatCardModule, MatSelectModule, MatInputModule, MatFormFieldModule, FormsModule, CommonModule, ReactiveFormsModule, MatButtonModule],
    templateUrl: './search-dialog.component.html',
    styleUrl: './search-dialog.component.scss'
})
export class SearchDialogComponent {
    public WorkflowElementType = WorkflowElementType;
    public elementTypeControl = new UntypedFormControl(null);
    public elementIdControl = new UntypedFormControl(null);

    /**
     * Constructeur.
     */
    constructor(
        public dialogRef: MatDialogRef<SearchDialogComponent>,
        protected notificationService: NotificationService
    ) {}

    public cancel() {
        this.dialogRef.close(null);
    }

    public search() {
        if (this.elementTypeControl.value === null) {
            this.notificationService.displayWarning('Erreur de recherche', "Le type de l'élément recherché doit être renseigné.");
            return;
        }

        if (!this.elementIdControl.value) {
            this.notificationService.displayWarning('Erreur de recherche', "L'id de l'élément recherché doit être renseigné.");
            return;
        }

        if (isNaN(this.elementIdControl.value)) {
            this.notificationService.displayWarning('Erreur de recherche', "L'id de l'élément recherché doit être un entier.");
            return;
        }
        let elementId = Number.parseInt(this.elementIdControl.value);

        this.dialogRef.close(new SearchDialogResult(this.elementTypeControl.value, elementId));
    }
}
